module.exports = __webpack_public_path__ + "d833c2968e08b87c4102d8a7ee3176a5.png";